import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Avatar,
  Typography,
  Chip,
  Divider,
  Stack,
} from '@mui/material';
import {
  LocalHospital,
  Business,
  Phone,
  Email,
  LocationOn
} from '@mui/icons-material';
import { Doctor } from '../types';

/** Matches prior `value || 'N/A'` for optional string fields (null, undefined, ''). */
function displayOrNa(value: string | null | undefined): string {
  return value == null || value === '' ? 'N/A' : value;
}

interface DoctorProfileCardProps {
  doctor: Doctor;
}

export const DoctorProfileCard: React.FC<DoctorProfileCardProps> = ({ doctor }) => {
  return (
    <Card sx={{ height: '100%', borderRadius: 2, boxShadow: 2, position: "relative" }}>
      <Box sx={{ height: 70, background: "#AA5B17" }} />
      <CardContent sx={{ p: 3 }}>
        {/* Profile Header */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', mb: 3 }}>
          <Avatar
            alt={doctor?.name}
            sx={{ width: 100, height: 100, mb: 2, position: "absolute", top: 20 }}
          />
          <Typography variant="h5" fontWeight="bold" textAlign="left" sx={{ marginTop: 4 }}>
            {displayOrNa(doctor?.name)}
          </Typography>
          <Typography variant="body2" sx={{ color: "#E6B57E" }} textAlign="left" mt={0.5}>
            {displayOrNa(doctor?.specialty)}
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="left">
            {displayOrNa(doctor?.qualification)}
          </Typography>
          {doctor?.category && (
            <Chip
              label={doctor.category}
              color="primary"
              size="small"
              sx={{ mt: 1, width: "fit-content" }}
            />
          )}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Practice Information */}
        <Stack spacing={2}>
        {doctor?.business_category_name && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Business color="primary" fontSize="small" />
              <Typography variant="body2">{doctor.business_category_name}</Typography>
            </Box>
          )}
          {doctor?.location && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationOn color="primary" fontSize="small" />
              <Typography variant="body2">{doctor.location}</Typography>
            </Box>
          )}
          {doctor?.address && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocalHospital color="primary" fontSize="small" />
              <Typography variant="body2">{doctor.address}</Typography>
            </Box>
          )}
          {doctor?.phone && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Phone color="primary" fontSize="small" />
              <Typography variant="body2">{doctor.phone}</Typography>
            </Box>
          )}
          {doctor?.email && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Email color="primary" fontSize="small" />
              <Typography variant="body2">{doctor.email}</Typography>
            </Box>
          )}
          
        </Stack>
      </CardContent>
    </Card>
  );
};
